import React from 'react'
import { checkTranslation, chooseWallpaper, translate } from "../../utils/useful";
import FormBuilder from '../FormBuilder'
import { v4 as uuidv4 } from "uuid";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import { FormBuilderObjects, formBuilderGroups } from '../../variables/formBuilderData';
import inputComponents from '../../components/tableComponents';
import WidgetComponents from '../../components/widgets/WidgetComponents';
import { widgetsGroups, widgetsList } from '../../variables/widgetsList';
// import TextInput from '../../components/inputs/TextInput';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
// import CAHeader from '../../components/header/CAHeader';
import StagesManager from '../../components/StagesManager';

class CAFormBuilder extends React.Component {
    state = {
        type: 'dashboard',
        collectionName: null,
        btnToolbar: [
            { title: "Layout", stage: "one" },
            { title: "Data", stage: "two" },
        ],
        clicked: 'one',
        styleInfo: {
            textColor: '#fff'
        },
        showToolbar: true,
        headerConfig: {
            showToolbar: true, showSettings: true, showSettings: true, showFrames: 'createApplet', type: 'createApplet', isPortal: false, title: `${this.props.user?.info?.fullname}`,
        },
        componentsInfo: {
            form: { object: FormBuilderObjects, groups: formBuilderGroups, components: inputComponents },
            dashboard: { object: widgetsList, groups: widgetsGroups, components: WidgetComponents },
        },
        formContent: [
            {
                //Page
                pageId: uuidv4(),
                pageContent: [{
                    //Section
                    sectionId: uuidv4(),
                    sectionContent: [
                        {
                            rowId: uuidv4(),
                            rowContent: [

                            ],
                        }
                    ]
                }]

            }
        ],

    }

    componentDidMount() {
        if (this.props.initData) {
            let data = this.props.initData
            let { collectionName, formContent } = this.state
            if (data.collectionInfo) {

                if (data.collectionInfo.form) {
                    formContent = data.collectionInfo.form
                }
                if (data.collectionInfo.collectionName) {
                    collectionName = data.collectionInfo.collectionName
                }
                if (!collectionName) {
                    collectionName = translate("Untitled Collection")
                }

                // console.log(collectionName)
                this.setState({ collectionName, formContent }, () => {
                    this.props.setHeader("dummy", 1)
                })
            } else {

                collectionName = translate("Untitled Collection")

                this.setState({ collectionName }, () => {
                    this.props.setHeader("dummy", 1)
                })
            }
        }
        if (this.props.setHeader) {
            this.props.setHeader({
                'toolbar': this.toolbarView,
                'showToolbar': false,
                'title': translate('Form builder'),
                isPortal: true, doNotshowNotification: true,
                // 'title': `${this.props.user?.info?.fullname}`,
                topHeaderComponent: this.topHeaderComponent,
                // headerIdentityComponent: this.headerIdentityComponent,
                backAction: () => this.props.lastStage()
            })
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.initData != this.props.initData && this.props.initData) {
            let data = this.props.initData
            let { collectionName, formContent } = this.state
            if (data.collectionInfo) {
                if (data.collectionInfo.form) {
                    formContent = data.collectionInfo.form
                }
                if (data.collectionInfo.collectionName) {
                    collectionName = data.collectionInfo.collectionName
                }
                this.setState({ collectionName, formContent })
            }
        }
    }
    // setName = (value) => {
    //     this.setState({ name: value })
    // }
    handelClick = (stage) => {
        this.setState({ clicked: stage })
        this.innerStageManager.changeStage(stage)
    }
    toolbarView = () => {
        return (
            <>
                {this.state.btnToolbar.map((item, index) => {
                    return (
                        <button className='mrd-2 flexcc dark-blur-hover px-2 py-1 br-5' onClick={() => this.handelClick(item.stage)} style={{ backgroundColor: item.stage == this.state.clicked ? 'rgba(255, 255, 255, 0.1)' : '', minWidth: 20 }}>
                            <p className='white text-smaller text-semibold '>{item.title}</p>
                        </button>
                    )
                })}

            </>
        )
    }
    onDragStartAction = (e) => {
        this.PageBuilderMain.onDragStartAction(e)
    }
    changeValue = (key, value) => {
        this.setState({ [key]: value })
    }

    topHeaderComponent = () => {
        return (
            <div className='flexc'>
                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.Save}
                    isLoading={this.state.isLoadingData}
                    title='Next Step'
                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#000'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />
            </div>

        )
    }
    setName = (value) => {
        this.setState({ collectionName: value }, () => {
            this.props.setHeader("dummy", 1)

        })
    }
    headerIdentityComponent = () => {
        return (
            <div className='' >
                <div className='modern-input-header flexcc blue-box-border-h px-2 py-2 br-10 w-100' style={{ border: 'none' }}>
                    {/* <TextInput data={this.state.collectionName} changeValue={this.changeValue} styleInfo={this.state.styleInfo} header={{ key: 'collectionName', information: { rows: 1, placeholder: '{{lang}}Form Name ...' }, }} /> */}
                    <input onChange={(e) => this.setName(e.target.value)} data={this.state.collectionName} value={this.state.collectionName} className={' ' + this.props.colors?.iconInvert ? 'lightPlaceholder' : 'darkPlaceholder'} style={{ backgroundColor: 'transparent', border: 'none', color: this.props.colors.textColor }} placeholder={translate('Form Name ...')} />

                </div>
            </div>
        )
    }
    nextStage = (rawData, collectionName) => {
        if (rawData && collectionName?.trim()) {
            let data = this.props.initData
            if (!data.collectionInfo) {
                data.collectionInfo = {}
            }

            let form = rawData
            let fields = []

            if (form && form[0]) {
                form[0]?.pageContent[0]?.sectionContent?.map((prop) => {
                    prop.rowContent.map((element) => {
                        if (!element.key.includes('values.')) {
                            element.key = 'values.' + element.key
                        }
                        fields.push(element)
                    })
                })
            }



            data.collectionInfo.form = form
            data.collectionInfo.collectionName = collectionName


            this.props.setData(data, () => {
                this.props.setFrameFields(fields, 0, () => {

                    if (this.props.continue) {
                        this.props.continue(this.props.stageName)
                    } else {
                        this.props.changeStage('access')
                    }

                })
            })
        }
    }
    backStage = () => {
        this.stageManager.lastStage((stage) => {

            let showToolbar = false
            let shouldHaveToolbar = ['first', 0]
            if (shouldHaveToolbar.includes(stage)) {
                showToolbar = true
            }


            let showBackBtn = true
            let shouldHaveBackBtn = ['first', 0]
            if (shouldHaveBackBtn.includes(stage)) {
                showBackBtn = false
            }

            this.setState({ showToolbar, showBackBtn })

        })
    }
    Save = () => {
        this.setState({ isLoadingData: true })
        if (this.state.collectionName?.trim() == null || !this.state.collectionName?.trim()) {
            this.setState({ collectionName: null }, () => {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.NameRequired', description: '{{lang}}errors.NameRequired' })
                this.setState({ isLoadingData: false })
            })
        }
        if (this.onSave) {
            // let data = this.state.formContent
            if (this.formBuilder) {
                let data = this.formBuilder.getHeaders()
                // console.log('odatabject', data)
                let collectionName = this.state.collectionName
                this.onSave(data, collectionName)
                this.setState({ isLoadingData: false })
            }
        }
    }
    onSave = (data, name) => {
        // console.log('this.state.formContent', data)
        this.nextStage(data, name)
    }

    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    render() {

        return (
            <div className='w-100 h-100'>
                {/* <div className='w-100' style={{ position: 'sticky', top: 0, height: '96px' }}>
                    <CAHeader ref={el => this.header = el} config={this.state.headerConfig} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} features={this.props.applet?.features} />
                </div> */}
                <StagesManager ref={el => this.innerStageManager = el} height={'100%'}>
                    <FormBuilder ref={(el) => this.formBuilder = el} stage={0} stageName={'one'} noBtn={true} initData={this.props.initData?.collectionInfo?.form} collectionName={this.props.initData?.collectionInfo?.collectionName} width={this.props.width} onSave={this.onSave} lastStage={this.props.lastStage} saveTitle={translate('ca.Next Step')} language={this.props.language} />
                    <div stage={0} stageName={'two'}></div>
                </StagesManager>
            </div>
        )
    }
}
const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CAFormBuilder);